import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button, Modal, Text } from "@lookiero/sty-psp-ui";
import { useStaticInfo } from "../../../../../../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages } from "../../../../../../../i18n/i18n";
import { style as imagePickerModalStyle } from "./ImagePickerModal.style";

interface ImagePickerModalProps {
  readonly visible: boolean;
  readonly disabled?: boolean;
  readonly testID?: string;
  readonly onDismiss: () => void;
  readonly onTakePhoto: () => void;
  readonly onChooseFromLibrary: () => void;
}
const ImagePickerModal: FC<ImagePickerModalProps> = ({
  visible,
  disabled = false,
  testID,
  onDismiss,
  onTakePhoto,
  onChooseFromLibrary,
}) => {
  const {
    customer: { segment },
  } = useStaticInfo();

  const titleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.IMAGE_PICKER_MODAL_TITLE,
    values: { segment: segment.toLowerCase() },
  });
  const takePhotoButtonText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.IMAGE_PICKER_MODAL_TAKE_PHOTO_BUTTON,
    values: { segment: segment.toLowerCase() },
  });
  const chooseFromLibraryButtonText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.IMAGE_PICKER_MODAL_CHOOSE_FROM_LIBRARY_BUTTON,
    values: { segment: segment.toLowerCase() },
  });

  const style = useMemo(() => imagePickerModalStyle(), []);

  return (
    <Modal portalHostName="StyleProfile" testID={testID} visible={visible} showCloseButton onClose={onDismiss}>
      <View style={style.modal}>
        <Text level={1} variant="action">
          {titleText}
        </Text>

        <View style={style.modalGap}>
          <Button
            disabled={disabled}
            level={3}
            style={{ button: { ...style.button, ...style.takePhotoButton } }}
            variant="secondary"
            onPress={onTakePhoto}
          >
            {takePhotoButtonText}
          </Button>
          <Button
            disabled={disabled}
            level={3}
            style={{ button: style.button }}
            variant="secondary"
            onPress={onChooseFromLibrary}
          >
            {chooseFromLibraryButtonText}
          </Button>
        </View>
      </View>
    </Modal>
  );
};

export { ImagePickerModal };
